/* src/app/components/help/help-editor.component.css */
.editor-lede {
  color: var(--fg-2);
  font-size: var(--text-sm);
  max-width: 70ch;
}
.editor-note {
  color: var(--fg-3);
  font-size: var(--text-xs);
}
.editor-card {
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: var(--space-4);
  margin-bottom: var(--space-4);
  background: var(--bg-surface);
}
.editor-card-legend {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  float: none;
  width: auto;
  padding: 0 var(--space-2);
  margin-bottom: var(--space-3);
  font-size: var(--text-base);
  font-weight: var(--weight-semibold);
  color: var(--fg-1);
}
.editor-badge {
  font-size: 10px;
  font-weight: var(--weight-semibold);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--fg-3);
  background: var(--gray-100);
  border-radius: var(--radius-full);
  padding: 2px 8px;
}
.editor-badge--edited {
  color: var(--gold-700);
  background: var(--gold-100);
}
.editor-lang {
  border-top: 1px solid var(--border);
  padding-top: var(--space-3);
  margin-top: var(--space-3);
}
.editor-lang-name {
  font-size: var(--text-xs);
  font-weight: var(--weight-semibold);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--fg-3);
  margin-bottom: var(--space-2);
}
@media (min-width: 992px) {
  .editor-card {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 0 var(--space-4);
  }
  .editor-card-legend,
  .editor-card > .mt-2 {
    grid-column: 1 / -1;
  }
  .editor-lang {
    border-top: none;
    margin-top: 0;
  }
}
/*# sourceMappingURL=help-editor.component.css.map */
